(() => {
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '')) return;

  const prefetched = new Set();
  const maximumPrefetches = 4;

  const getEligibleUrl = (anchor) => {
    if (!anchor || anchor.target === '_blank' || anchor.hasAttribute('download')) return null;

    let url;
    try {
      url = new URL(anchor.href, window.location.href);
    } catch (_error) {
      return null;
    }

    if (url.origin !== window.location.origin || url.protocol !== window.location.protocol) return null;
    if (url.pathname === window.location.pathname && url.search === window.location.search) return null;
    if (/^\/(cart|checkout|account|challenge)(\/|$)/.test(url.pathname)) return null;

    url.hash = '';
    return url.href;
  };

  const prefetch = (anchor) => {
    const href = getEligibleUrl(anchor);
    if (!href || prefetched.has(href) || prefetched.size >= maximumPrefetches) return;

    prefetched.add(href);
    const schedule = window.requestIdleCallback || ((callback) => window.setTimeout(callback, 1));
    schedule(() => {
      const link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = href;
      document.head.appendChild(link);
    }, { timeout: 1500 });
  };

  const prefetchFromEvent = (event) => prefetch(event.target.closest?.('a[href]'));

  document.addEventListener('pointerover', prefetchFromEvent, { passive: true });
  document.addEventListener('touchstart', prefetchFromEvent, { passive: true });
  document.addEventListener('focusin', prefetchFromEvent);
})();
